import { render, staticRenderFns } from "./UiTournamentItem.vue?vue&type=template&id=72884350&"
import script from "./UiTournamentItem.vue?vue&type=script&lang=js&"
export * from "./UiTournamentItem.vue?vue&type=script&lang=js&"
import style0 from "./UiTournamentItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports